import _ from 'lodash'

export const isAuthenticatedCheck = (auth, now) => (
  (auth && auth.token && auth.expire &&
   auth.expire > ((now ? now : Date.now()) / 1000)) ||
  false)

export const normalizeMinions = (state, stateKeys) => {
  let minionIds = _.keys((stateKeys || {}).minions||{})
  minionIds = minionIds.concat(_.keys(state.grains||{}), _.keys(state.status||{}))
  return _
    .chain(minionIds)
    .uniq()
    .map(mid => {
      return [mid, {
        fingerprint: ((stateKeys||{}).minions||{})[mid] || null,
        grains: (state.grains||{})[mid] || {},
        status: (state.status||{})[mid] || false,
      }]
    })
    .fromPairs()
    .value()
}

export const normalizeJobs = (stateJobs) => {
  return _
    .chain(stateJobs)
    .toPairs()
    .filter(item => (item[1].Function||'') !== 'saltutil.find_job')
    .fromPairs()
    .value()
}

export function setStateChanges(handlers, payloads) {

  if (this._prevent_any_status_changes) {
    console.log('setStateChanges prevented any status changes')
    return
  }
  if (_.isString(handlers)) {
    handlers = [handlers]
    payloads = [payloads]
  }
  _.forEach(handlers, (handler, i) => {
    if (_.isFunction(this.__actionHandlers[handler])) {
      this.dispatch(this.createAction(handler)(payloads[i]))
      console.log('setStateChanges dispatched: ', handler, payloads[i])
    }
  })
}

export function setBusy () {
  if (!this._prevent_async_status_changes &&
      !this._prevent_any_status_changes)
    if (!this.async.busy) this.async.setBusy()
}
export function setDone () {
  if (!this._prevent_async_status_changes &&
      !this._prevent_any_status_changes)
    if (!this.async.done) this.async.setDone()
}
export function setError (err) {
  if (!this._prevent_async_status_changes &&
      !this._prevent_any_status_changes)
    this.async.setError(err)
  else
    throw err
}

export const commonChildApiProps = (saltApi, self) => {
  return {
    _saltApi: {enumerable:false, get: () => saltApi},
    _prevent_async_status_changes: {enumerable:false, get: () => saltApi._prevent_async_status_changes},
    _prevent_any_status_changes: {enumerable:false, get: () => saltApi._prevent_any_status_changes},
    aio: {enumerable:false, get: () => saltApi.aio},
    setStateChanges: {enumerable:false, get: () => setStateChanges.bind(self) }
  }
}



// WEBPACK FOOTER //
// ./src/saltapi/commonUtils.js